////////////////////////////
//ITINERARIES
////////////////////////////
export const FETCH_ITINERARIES = 'FETCH_ITINERARIES';
export const FETCH_ITINERARIES_FAIL = 'FETCH_ITINERARIES_FAIL';

export const POST_ITINERARIES_LOADING = 'POST_ITINERARIES_LOADING';
export const POST_ITINERARIES = 'POST_ITINERARIES';
export const POST_ITINERARIES_FAIL = 'POST_ITINERARIES_FAIL';
////////////////////////////
//CAPACITY
////////////////////////////
export const FETCH_SEQUENCE_CAPACITY_LOADING = 'FETCH_SEQUENCE_CAPACITY_LOADING';
export const FETCH_SEQUENCE_CAPACITY = 'FETCH_SEQUENCE_CAPACITY';
export const FETCH_SEQUENCE_CAPACITY_FAIL = 'FETCH_SEQUENCE_CAPACITY_FAIL';
export const FETCH_CAPACITY = 'FETCH_CAPACITY';
export const FETCH_LIVE_CAPACITY = 'FETCH_LIVE_CAPACITY';
export const FETCH_CAPACITY_FAIL = 'FETCH_CAPACITY_FAIL';
export const FETCH_LIVE_CAPACITY_FAIL = 'FETCH_LIVE_CAPACITY_FAIL';
export const SAVE_CAPACITY = 'SAVE_CAPACITY';
export const FETCH_EDIT_CAPACITY = 'FETCH_EDIT_CAPACITY';
export const FETCH_EDIT_CAPACITY_FAIL = 'FETCH_EDIT_CAPACITY_FAIL';
export const FETCH_EDIT_CAPACITY_LOADING = 'FETCH_EDIT_CAPACITY_LOADING';
////////////////////////////

////////////////////////////
//NATIONALITY
////////////////////////////
export const SAVE_NATIONALITY = 'SAVE_NATIONALITY';
export const FETCH_NATIONALITY = 'FETCH_NATIONALITY';
export const FETCH_NATIONALITY_FAIL = 'FETCH_NATIONALITY_FAIL';
////////////////////////////

////////////////////////////
//BOOKING
////////////////////////////
export const RESET_BOOKING = 'RESET_BOOKING';

export const BOOK_TOUR = "BOOK_TOUR";
export const BOOK_TOUR_FAIL = "BOOK_TOUR_FAIL";
export const FETCH_TOUR = "FETCH_TOUR";
export const FETCH_TOUR_FAIL = "FETCH_TOUR_FAIL";
export const UPDATE_TOUR_INFORMATION_LOADING = "UPDATE_TOUR_INFORMATION_LOADING";
export const UPDATE_TOUR_INFORMATION = "UPDATE_TOUR_INFORMATION";
export const UPDATE_TOUR_INFORMATION_FAIL = "UPDATE_TOUR_INFORMATION_FAIL";
export const DELETE_TOUR_INFORMATION = "DELETE_TOUR_INFORMATION";
export const DELETE_TOUR_INFORMATION_FAIL = "DELETE_TOUR_INFORMATION_FAIL";
export const ADD_TOUR_INFORMATION = "ADD_TOUR_INFORMATION";
export const ADD_TOUR_INFORMATION_FAIL = "ADD_TOUR_INFORMATION_FAIL";


export const SET_CURRENCY = "SET_CURRENCY";
export const SET_DEPARTURE = 'SET_DEPARTURE';
export const SET_TOURID = 'SET_TOURID';
export const SET_PROMO_CODE = 'SET_PROMO_CODE';
export const SET_CITYID = 'SET_CITYID';
export const SET_PASSENGER_TYPE = "SET_PASSENGER_TYPE";
export const SET_PASSENGER_DETAILS = "SET_PASSENGER_DETAILS";
export const SET_PROCESSING = "SET_PROCESSING";
export const SET_BOOKING = "SET_BOOKING";
export const SET_BOOKING_GROUP = "SET_BOOKING_GROUP";
export const SET_PRICES = "SET_PRICES";
export const SET_LOCKOUT = "SET_LOCKOUT";
export const SET_TRIPS_PASSENGERS = "SET_TRIPS_PASSENGERS";
export const ADD_TRIPS = "ADD_TRIPS";
export const SET_TOUR_NAME_OVERRIDE = "SET_TOUR_NAME_OVERRIDE"; 
////////////////////////////

////////////////////////////
//DISCOUNT
////////////////////////////
export const FETCH_DISCOUNT = "FETCH_DISCOUNT";
export const FETCH_DISCOUNT_FAIL = "FETCH_DISCOUNT_FAIL";
export const FETCH_DISCOUNT_VALID = "FETCH_DISCOUNT_VALID";
export const DISCOUNT_RESET = 'DISCOUNT_RESET';
////////////////////////////

////////////////////////////
//ERRORS MESSAGE
////////////////////////////
export const SAVE_ERROR_MESSAGE = 'SAVE_ERROR_MESSAGE';
export const FETCH_ERROR_MESSAGE = 'FETCH_ERROR_MESSAGE';
export const FETCH_ERROR_MESSAGE_FAIL = 'FETCH_ERROR_MESSAGE_FAIL';
////////////////////////////

////////////////////////////
//CURRENCY
////////////////////////////
export const SAVE_CURRENCY = 'SAVE_CURRENCY';
////////////////////////////

////////////////////////////
//INFO
////////////////////////////
export const FETCH_INFO = 'FETCH_INFO';
export const FETCH_INFO_FAIL = 'FETCH_INFO_FAIL';
export const FETCH_FULL_INFO = 'FETCH_FULL_INFO';
export const FETCH_FULL_INFO_FAIL = 'FETCH_FULL_INFO_FAIL';
////////////////////////////


////////////////////////////
//CITIES
////////////////////////////
export const FETCH_CITIES = 'FETCH_CITIES';
export const FETCH_CITIES_FAIL = 'FETCH_CITIES_FAIL';
////////////////////////////


////////////////////////////
//CURRENCY
////////////////////////////
export const FETCH_CURRENCY = 'FETCH_CURRENCY';
export const FETCH_CURRENCY_FAIL = 'FETCH_CURRENCY_FAIL';
////////////////////////////


////////////////////////////
//SEQUENCES
////////////////////////////
export const FETCH_SEQUENCE = "FETCH_SEQUENCE";
export const FETCH_SEQUENCE_FAIL = "FETCH_SEQUENCE_FAIL";

export const FETCH_SEQUENCES = "FETCH_SEQUENCES";
export const FETCH_SEQUENCES_FAIL = "FETCH_SEQUENCES_FAIL";
export const FETCH_SEQUENCES_LOADING = "FETCH_SEQUENCES_LOADING";

////////////////////////////
//CONTENTFUL
////////////////////////////
export const FETCH_CONTENTFUL = 'FETCH_CONTENTFUL';
export const FETCH_CONTENTFUL_FAIL = 'FETCH_CONTENTFUL_FAIL';


////////////////////////////
//PRODUCTS
////////////////////////////
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';
export const FETCH_PRODUCTS_FAIL = 'FETCH_PRODUCTS_FAIL';
export const FETCH_CYOA_PRODUCTS = 'FETCH_CYOA_PRODUCTS';
export const FETCH_CYOA_PRODUCTS_FAIL = 'FETCH_CYOA_PRODUCTS_FAIL';
export const SAVE_PRODUCT = 'SAVE_PRODUCT';

////////////////////////////
//DESTINATIONS
////////////////////////////
export const FETCH_DESTINATIONS = 'FETCH_DESTINATION';
export const FETCH_DESTINATIONS_FAIL = 'FETCH_DESTINATION_FAIL';


////////////////////////////
//BUILDER
////////////////////////////
export const ADD_SEQUENCES_LOADING = "ADD_SEQUENCES_LOADING";
export const ADD_SEQUENCES = "ADD_SEQUENCES";
export const ADD_SEQUENCES_FAIL = "ADD_SEQUENCES_FAIL";
export const SET_BUILDER_CITY = "SET_BUILDER_CITY";
export const ADD_BUILDER_ITEM = "ADD_BUILDER_ITEM";
export const REMOVE_BUILDER_ITEM = "REMOVE_BUILDER_ITEM";
export const ADD_RESERVATION_ITEM = "ADD_RESERVATION_ITEM";
export const REMOVE_RESERVATION_ITEM = "REMOVE_RESERVATION_ITEM";
export const CLEAR_BUILDER_LIST = "CLEAR_BUILDER_LIST";


////////////////////////////
//UTILS
////////////////////////////
export const SET_FOOTER_MODAL = 'SET_FOOTER_MODAL';



// WEBPACK FOOTER //
// ./src/actions/types.js